import type { SearchContextType } from '@gat-ship/types'

// No icon field on purpose: the dialog items carry their own icons,
// and keeping this module icon-free keeps the model layer importable
// from plain-ts unit tests (no .vue transform needed).
export interface SearchContextMetadata {
  title: string
  description: string
  /** The tag-input shorthand — typing `<prefix>:` in the search input selects this context. */
  prefix: string
}

export const searchContextMetadata: Record<
  SearchContextType,
  SearchContextMetadata
> = {
  global: {
    title: 'All',
    description: 'Search in all contexts',
    prefix: 'G'
  },
  client: {
    title: 'Clients',
    description: 'Search for clients',
    prefix: 'C'
  },
  vendors: {
    title: 'Vendors',
    description: 'Search for vendors',
    prefix: 'V'
  },
  otherParties: {
    title: 'Other Parties',
    description: 'Search for other parties',
    prefix: 'OP'
  },
  contacts: {
    title: 'Contacts',
    description: 'Search for contacts',
    prefix: 'CT'
  },
  navigation: {
    title: 'Navigation',
    description: 'Search for navigation',
    prefix: 'N'
  }
} as const
